<script setup lang="ts">
import { updateorAddMetaTag } from "@/utils/functions";
import { onBeforeUnmount, onMounted } from "vue";
import { defineAsyncComponent } from 'vue';

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));
const Link = defineAsyncComponent(() => import('@/views/components/Link.vue'));


let metaTag: any;
onMounted(() => {
    metaTag = document.createElement("meta");
    metaTag.name = "robots";
    metaTag.content = "index, follow";
    document.head.appendChild(metaTag);

    document.querySelector('link[rel="canonical"]')?.setAttribute('href', document.location.href);
    updateorAddMetaTag('description', '');
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0)
    }
})

onBeforeUnmount(() => {
    if (metaTag && document.head.contains(metaTag)) {
        document.head.removeChild(metaTag);
    }
})
</script>

<template>
    <Default>
        <!-- BEGIN: Content-->
        <div class="app-content content pt-5"
            style="min-height:75%; margin-left: 0px; margin-top: 6rem; background-color: white;">
            <main id="main">
                <!-- ======= Breadcrumbs ======= -->
                <section id="breadcrumbs" class="breadcrumbs">
                    <div class="container">
                        <h1>Conditions générales d’utilisation topela</h1>
                    </div>
                </section><!-- End Breadcrumbs -->

                <div class="container">
                    <div class="py-0 h-style h5-style use-poppins"
                        style="font-style: italic;font-size:16px !important;color:black">
                        Mise à jour le 22 septembre 2026.
                    </div>
                </div>

                <section class="py-0 about">
                    <div class="container">
                        <div class="row mb-0">
                            <div
                                class="col-12 icon-boxes d-flex flex-column align-items-stretch justify-content-center ">
                                <span class="h3 h-style h3-style use-poppins mb-2"> Définition </span>
                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Application Mobile topela</div>
                                    <p>
                                        Désigne l’application mobile (appelée aussi app topela) disponible sur Google
                                        Play et Apple Store,
                                        qui offre aux Utilisateurs Professionnels des Services de mise en relation, de
                                        devis, de gestion de prestations et de factures pour entrepreneurs.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Plateforme topela</div>
                                    <p>
                                        Désigne l’ensemble des moyens informatiques mis en œuvre par Webck pour offrir
                                        les Services à ses Utilisateurs Clients et Professionnels (tels que définis
                                        ci-dessous),
                                        notamment par la mise à disposition de l’Application Mobile topela et du Site
                                        Web.
                                    </p>
                                </div>


                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Site Web</div>
                                    <p>
                                        Désigne le site Internet mis à la disposition du public par Webck SAS par le
                                        biais d’Internet à l’adresse URL
                                        <a href="https://123topela.fr"
                                            style="text-decoration: underline !important;color:#0070C0 !important;"
                                            target="_blank">https://123topela.fr</a>
                                        (ou à l’adresse de l’un ou l’autre des sous-domaines du site précité) et qui
                                        inclut l’Espace Client topela.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Utilisateur</div>
                                    <p>
                                        Désigne un Utilisateur Client ou un Utilisateur Professionnel.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Utilisateur Client</div>
                                    <p>
                                        Désigne la personne physique capable de plus de 18 ans utilisant les Services
                                        par le biais du Site Web.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Utilisateur Professionnel</div>
                                    <p>
                                        Désigne l’entreprise et/ou la société inscrite au registre du commerce et des
                                        sociétés utilisant les Services par le biais de l’Application Mobile topela et
                                        du Site Web.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="py-0 about">
                    <div class="container">
                        <div class="row">
                            <div
                                class="col-12 icon-boxes d-flex flex-column align-items-stretch justify-content-center ">
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">1. Objet </div>
                                    <p>
                                        Les présentes conditions générales d’utilisation (CGU) ont pour objet de définir
                                        les modalités et conditions
                                        d’utilisation des services proposés sur la Plateforme topela (ci-après : les «
                                        <strong>Services</strong> »), ainsi que de définir les droits et obligations des
                                        parties dans ce cadre.
                                    </p>
                                    <p>
                                        Les CGU sont accessibles sur ce Site Internet et imprimables à tout moment par
                                        un lien direct en bas de la page d’accueil du Site.
                                    </p>
                                    <p>
                                        Elles peuvent être complétées, le cas échéant, par des conditions d’utilisation
                                        particulières à certains Services. En cas de contradiction, les conditions
                                        particulières prévalent sur ces conditions générales.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">2. Exploitant des Services </div>
                                    <p>
                                        Les Services sont exploités par la société Webck, Société par actions simplifiée
                                        au capital de 25 000 €,
                                        immatriculée au RCS de Nanterre sous le n°904 029 014, dont le siège social est
                                        situé 6 avenue Edouard Herriot, 92350 LE PLESSIS-ROBINSON (ci-après : <strong>«
                                            Webck »</strong>).
                                    </p>
                                    <p>
                                        Webck peut être contactée aux coordonnées suivantes : <br>
                                        Adresse postale : 6 avenue Edouard Herriot, 92350 LE PLESSIS-ROBINSON. <br>
                                        Adresse électronique : <a href="mailto:admin@webck.fr"
                                            style="text-decoration: underline;color:blue">admin@webck.fr</a>.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">3. Accès à la Plateforme topela et aux
                                        Services </div>
                                    <div>
                                        Les Services sont accessibles, sous réserve des restrictions prévues sur la
                                        Plateforme topela :
                                        <ul>
                                            <li>
                                                à toute personne physique disposant de la pleine capacité juridique pour
                                                s’engager au titre des présentes conditions générales.
                                                La personne physique qui ne dispose pas de la pleine capacité juridique
                                                ne peut accéder au Site et aux Services qu’avec l’accord de son
                                                représentant légal ;
                                            </li>
                                            <li>
                                                à toute personne morale agissant par l’intermédiaire d’une personne
                                                physique disposant de la capacité juridique pour contracter au nom et
                                                pour le compte de la personne morale.
                                            </li>
                                        </ul>
                                    </div>
                                    <p>
                                        Etant précisé que l’utilisation des Services topela est réservée aux
                                        Utilisateurs qui résident en France métropolitaine et dans les DOM/TOM. Les
                                        dates et heures affichées sont celles du fuseau horaire de Paris (GMT+1).
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">4. Acceptation des conditions générales
                                    </div>
                                    <p>
                                        L’acceptation des présentes conditions générales est matérialisée par une case à
                                        cocher prévue à cet effet sur le Site Web et sur l’Application Mobile topela,
                                        lors de l’inscription de l’Utilisateur en tant qu’Utilisateur Client (sur le
                                        Site Web) ou en tant qu’Utilisateur Professionnel (sur l’Application Mobile).
                                        Cette acceptation ne peut être que pleine et entière.
                                        Toute adhésion sous réserve est considérée comme nulle et non avenue.
                                        L’Utilisateur qui n’accepte pas d’être lié par les présentes conditions
                                        générales ne doit pas utiliser les Services.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">5. Descriptif des Services</div>
                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">1. Nature des Services
                                        proposés par la Plateforme</div>
                                    <p>
                                        L’Utilisateur a accès aux Services décrits sur la Plateforme topela, sous une
                                        forme et selon les fonctionnalités et moyens techniques que Webck juge les plus
                                        appropriés.
                                    </p>
                                    <p>
                                        La Plateforme topela offre un service de bout en bout visant à faciliter la
                                        relation d’affaires entre les entrepreneurs et leurs clients. Ces services ont
                                        été conçus pour être utilisés en toute autonomie par les Utilisateurs.
                                    </p>
                                    <p>La Plateforme topela permet notamment aux Utilisateurs, Professionnels et Clients
                                        :</p>
                                    <div>
                                        <ul>
                                            <li>
                                                D’entrer en contact grâce à un moteur de recherche et de communiquer,
                                                s’ils le souhaitent, via un service de messagerie intégrée.
                                            </li>
                                            <li>
                                                Pour l’Utilisateur Client, de poster des demandes de prestation et
                                                d'être informé quand un Utilisateur Professionnel est intéressé par une
                                                demande (le choix d’entrer en contact avec un professionnel relevant
                                                toujours de la décision du client).
                                            </li>
                                            <li>
                                                De partager des devis pour la réalisation de prestations de service,
                                                avec la possibilité pour l’Utilisateur Client de signer électroniquement
                                                un devis qu’il souhaitera accepter.
                                            </li>
                                            <li>
                                                De partager un suivi de l’exécution des prestations.
                                            </li>
                                            <li>
                                                De partager les factures émises par l’Utilisateur Professionnel pour le
                                                paiement des prestations par l’Utilisateur Client (le paiement
                                                s’effectuant en dehors de la Plateforme topela).
                                            </li>
                                            <li>
                                                D’être notifiés automatiquement lors d’étapes clés de leur relation
                                                d’affaires (par exemple, lors de l’envoi d’un devis).
                                            </li>
                                        </ul>
                                    </div>
                                    <p>La Plateforme agit en qualité d’intermédiaire technique. Elle ne participe pas à
                                        la conclusion ni à l’exécution des contrats conclus entre les Utilisateurs et
                                        n’intervient pas dans la réalisation des prestations.</p>
                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">2. Mise en relation avec un
                                        magasin partenaire</div>
                                    <p>Dans le cadre de certains partenariats commerciaux, la Plateforme peut permettre
                                        à un Utilisateur Professionnel de solliciter une mise en relation entre un
                                        Utilisateur Client et un magasin partenaire.</p>
                                    <p>La transmission des coordonnées du Client au partenaire est strictement
                                        conditionnée à la validation explicite de celui-ci via le mécanisme de
                                        consentement prévu par la Plateforme.<br>
                                        Aucune donnée personnelle n’est transmise sans ce consentement.</p>
                                    <p>
                                        Le magasin partenaire intervient uniquement en qualité de tiers dans le cadre du
                                        partenariat commercial.<br>
                                        Il n’est pas partie aux relations contractuelles entre le Client et le
                                        Professionnel et n’assume aucune responsabilité au titre des prestations
                                        réalisées.
                                    </p>
                                    <p>
                                        La Plateforme n’intervient pas dans les relations commerciales entre le magasin
                                        partenaire, le Client et le Professionnel.<br>
                                        Elle ne saurait être tenue responsable :
                                    </p>
                                    <ul>
                                        <li>de la qualité des prestations réalisées,</li>
                                        <li>des litiges pouvant survenir entre Utilisateurs,</li>
                                        <li>des retards, malfaçons ou inexécutions contractuelles,</li>
                                        <li>des conséquences financières ou juridiques liées aux prestations.</li>
                                    </ul>
                                    <p>L’Utilisateur Professionnel s’engage à ne pas contourner les mécanismes de
                                        consentement mis en place par la Plateforme et à informer le Client de
                                        l’existence de cette procédure.</p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">6. Services gratuits / payants </div>
                                    <p>
                                        Les Services fournis aux Utilisateurs Clients le sont à titre gratuit.
                                    </p>
                                    <p>
                                        L’Application Mobile topela, destinée aux Utilisateurs Professionnels offrant
                                        deux modes d’utilisation (tels que décrits ci-dessous), les Services qui sont
                                        fournis aux Utilisateurs Professionnels le sont pour partie gratuits et pour
                                        partie payants :
                                    </p>
                                    <ul>
                                        <li>
                                            <div class="h4 h-style h4-style use-poppins"
                                                style="color:black !important;margin-bottom:0px !important">Services
                                                gratuits fournis à l’Utilisateur Professionnel (Utilisateur inscrit)
                                            </div>
                                            <p>
                                                Après installation par l’Utilisateur Professionnel de l’Application
                                                mobile et inscription selon la procédure prévue à l’article 7 ci-après,
                                                l’Utilisateur Professionnel pourra bénéficier d’un ensemble de
                                                fonctionnalités gratuites et sans engagement telles que décrites sur le
                                                Site Web public, notamment la possibilité de rendre son profil
                                                professionnel visible aux internautes sur le Site Web, d’être contacté
                                                par des Utilisateurs Clients via la messagerie intégrée et de réaliser
                                                des devis en mode « démonstration ».
                                            </p>
                                        </li>
                                        <li>
                                            <div class="h4 h-style h4-style use-poppins"
                                                style="color:black !important;margin-bottom:0px !important">Services
                                                payants fournis à l’Utilisateur Professionnel (Utilisateur abonné)</div>
                                            <p>
                                                Sous réserve de souscrire préalablement un abonnement et d’accepter les
                                                <a style="text-decoration: underline !important;color:#0070C0 !important;"
                                                    target="_blanc" href="/general-conditions-of-sale">Conditions
                                                    générales de vente</a> de Webck, l’Utilisateur Professionnel pourra
                                                bénéficier des fonctionnalités
                                                supplémentaires payantes ayant pour but de lui faciliter son quotidien
                                                administratif (devis, suivi de prestations, facturation). L’utilisateur
                                                Professionnel qui souhaite
                                                bénéficier de ces Services payants doit se reporter aux <a
                                                    style="text-decoration: underline !important;color:#0070C0 !important;"
                                                    target="_blanc" href="/general-conditions-of-sale">Conditions
                                                    générales de vente</a> de Webck,
                                                accessibles via le Site Web ou l’Application Mobile topela, afin
                                                d’obtenir davantage d’informations sur le contenu des Services payants,
                                                les conditions et modalités d’abonnement.
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">7. Utilisation des Services</div>
                                    <p>
                                        Les Services fournis aux Utilisateurs Clients le sont via le Site Web.
                                    </p>
                                    <p>
                                        Les Services fournis aux Utilisateurs Professionnels le sont essentiellement via
                                        l’Application Mobile topela, sous réserve pour l’Utilisateur de disposer
                                        d’une connexion internet suffisante sur son smartphone. L’utilisation optimale
                                        des Services via l’Application Mobile topela nécessite l’acceptation par
                                        l’Utilisateur Professionnel des notifications, du téléchargement de fichiers, de
                                        l’accès à l’appareil photo et à l’enregistrement audio de son smartphone.
                                    </p>
                                    <p>
                                        Que l’Utilisateur soit un Utilisateur Client ou Professionnel, l’utilisation des
                                        Services nécessite qu’il s’inscrive sur le Site et/ou sur l’Application Mobile
                                        topela, en remplissant le formulaire prévu à cet effet.
                                        L’Utilisateur doit fournir l’ensemble des informations marquées comme
                                        obligatoires. Toute inscription incomplète ne sera pas validée.
                                    </p>
                                    <p>
                                        L’inscription entraîne automatiquement l’ouverture d’un compte au nom de
                                        l’Utilisateur (ci-après : le <strong>« Compte »</strong>), lui donnant accès à
                                        un espace personnel (ci-après : l'<strong>« Espace Personnel »</strong>) qui lui
                                        permet de gérer son
                                        utilisation des Services sous une forme et selon les moyens techniques que Webck
                                        juge les plus appropriés pour rendre lesdits Services.
                                    </p>
                                    <p>
                                        L’Utilisateur garantit que toutes les informations qu’il donne dans le
                                        formulaire d’inscription sont exactes, à jour et sincères et ne sont entachées
                                        d’aucun caractère trompeur.
                                    </p>
                                    <p>
                                        Il s’engage à mettre à jour ces informations dans son Espace Personnel en cas de
                                        modifications, afin qu’elles correspondent toujours aux critères susvisés.
                                    </p>
                                    <p>
                                        L’Utilisateur est informé et accepte que les informations saisies aux fins de
                                        création ou de mise à jour de son Compte vaillent preuve de son identité. Les
                                        informations saisies par l’Utilisateur l’engagent dès leur validation.
                                    </p>
                                    <p>
                                        L’Utilisateur peut accéder à tout moment à son Espace Personnel après s’être
                                        identifié à l’aide de son identifiant de connexion ainsi que de son mot de
                                        passe.
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage à utiliser personnellement les Services et à ne permettre
                                        à aucun tiers de les utiliser à sa place ou pour son compte, sauf à en supporter
                                        l’entière responsabilité.
                                    </p>
                                    <p>
                                        Il est pareillement responsable du maintien de la confidentialité de son
                                        identifiant et de son mot de passe. Il doit immédiatement contacter Webck aux
                                        coordonnées mentionnées à l’article 2 des présentes s’il remarque que son Compte
                                        a été utilisé à son insu.
                                        Il reconnaît à Webck le droit de prendre toutes mesures appropriées en pareil
                                        cas.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">8. Assistance</div>
                                    <p>
                                        Webck met à disposition des Utilisateurs une assistance par messagerie
                                        électronique, accessible soit via la rubrique « Nous contacter » du Site Web,
                                        soit par email envoyé directement à <a href="mailto:sav@123topela.fr"
                                            style="text-decoration: underline;color:blue">sav@123topela.fr</a>,
                                        tous les jours de 9h à 19h, pour répondre à toutes ses questions sur le
                                        fonctionnement de la Plateforme topela.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">9. Spécificités liées aux Services «
                                        devis »</div>
                                    <p>
                                        Les Utilisateurs Clients et Professionnels sont informés que :
                                    </p>
                                    <div>
                                        <ul>
                                            <li>
                                                Lors de l’édition d’un devis par l’Utilisateur Professionnel, le calcul
                                                des prix est réalisé en arrondissant les montants au centième d’euro
                                                supérieur. Par exemple si
                                                le prix toutes taxes comprises d'une unité d'œuvre est de 10,365 €
                                                compte tenu de l'application d'une TVA à 5,5%, alors le prix appliqué
                                                sera de 10,37 €.
                                            </li>
                                            <li>
                                                L’adresse de l’Utilisateur Client mentionnée sur un devis envoyé par
                                                l’Utilisateur Professionnel via la Plateforme topela correspond à
                                                l’adresse de réalisation des prestations (i.e. adresse de prestation
                                                pour des travaux dans le bâtiment).
                                            </li>
                                            <li>
                                                L'envoi de révisions sur un devis par l’Utilisateur Client équivaut à un
                                                refus contractuel de ce devis. Cette action étant irréversible, le devis
                                                ne pourra plus être accepté.
                                                L’Utilisateur Professionnel devra donc, le cas échéant, procéder à
                                                l’envoi d’un autre devis au client.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">10. Spécificités liées au Service de
                                        facturation électronique</div>
                                    <p>
                                        La Plateforme topela permet à l’Utilisateur Professionnel d’accéder à des
                                        fonctionnalités de facturation électronique, notamment la création de factures
                                        au format Factur-X, leur transmission électronique ainsi que la réception et la
                                        consultation de factures fournisseurs.
                                    </p>
                                    <p>
                                        Topela intervient en qualité de Solution Compatible avec la facturation
                                        électronique. Webck n’est pas une Plateforme Agréée par l’administration
                                        fiscale.
                                    </p>
                                    <p>
                                        Les opérations réglementaires d’émission, de transmission et de réception des
                                        factures électroniques ainsi que, le cas échéant, la transmission des données de
                                        facturation, de transaction et de paiement à l’administration fiscale sont
                                        réalisées par l’intermédiaire d’une Plateforme Agréée partenaire, actuellement
                                        Pennylane.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.1. Activation du Service
                                    </div>
                                    <p>
                                        L’utilisation du Service de facturation électronique nécessite la création ou
                                        l’association d’un compte auprès de Pennylane.
                                    </p>
                                    <p>
                                        À cette fin, l’Utilisateur Professionnel autorise Webck à transmettre à
                                        Pennylane les informations et données strictement nécessaires à la création, à
                                        l’association et au fonctionnement de son compte, notamment ses informations
                                        d’identification, ses coordonnées professionnelles et ses données de
                                        facturation.
                                    </p>
                                    <p>
                                        L’activation du Service peut être soumise à la validation de ces informations
                                        ainsi qu’à l’acceptation par l’Utilisateur Professionnel des conditions
                                        générales d’utilisation, des conditions générales de vente et, plus
                                        généralement, des conditions contractuelles de Pennylane.
                                    </p>
                                    <p>
                                        La relation contractuelle relative aux services directement fournis par
                                        Pennylane est établie entre l’Utilisateur Professionnel et Pennylane.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.2. Émission et
                                        transmission des factures</div>
                                    <p>
                                        Les factures créées dans Topela peuvent être générées dans un format
                                        électronique pris en charge par le Service, notamment au format Factur-X.
                                    </p>
                                    <p>
                                        Lorsque l’Utilisateur Professionnel bénéficie d’un abonnement Topela incluant
                                        cette fonctionnalité, ses factures peuvent être transmises automatiquement
                                        depuis Topela à Pennylane en vue de leur traitement et de leur acheminement
                                        électronique.
                                    </p>
                                    <p>
                                        En l’absence d’un abonnement Topela incluant la transmission automatisée,
                                        l’Utilisateur Professionnel peut accéder à son espace Pennylane, y importer ses
                                        factures de vente et demander directement leur envoi électronique, selon les
                                        fonctionnalités et conditions proposées par Pennylane.
                                    </p>
                                    <p>
                                        Une facture ne doit être considérée comme valablement transmise qu’après
                                        confirmation de son acceptation par la Plateforme Agréée. Tout rejet ou toute
                                        anomalie peut nécessiter une correction ou une nouvelle intervention de
                                        l’Utilisateur Professionnel.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.3. Réception des factures
                                        fournisseurs</div>
                                    <p>
                                        Les factures électroniques reçues pour le compte de l’Utilisateur Professionnel
                                        par l’intermédiaire de Pennylane peuvent être synchronisées et rendues
                                        accessibles dans son espace Topela, notamment dans la rubrique consacrée aux
                                        achats.
                                    </p>
                                    <p>
                                        Le délai d’affichage d’une facture dans Topela peut dépendre des délais de
                                        traitement de Pennylane, de la plateforme utilisée par l’émetteur ou de tout
                                        autre intervenant participant à sa transmission.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.4. Limite d’utilisation
                                        gratuite</div>
                                    <p>
                                        Le Service permet de traiter gratuitement jusqu’à 1 200 documents au total par
                                        année civile, tous types de documents confondus, notamment les devis, factures,
                                        avoirs et autres documents pris en compte par Pennylane.
                                    </p>
                                    <p>
                                        Le nombre de documents utilisés est déterminé conformément aux règles de
                                        comptabilisation appliquées par Pennylane.
                                    </p>
                                    <p>
                                        Lorsque cette limite est atteinte, l’Utilisateur Professionnel peut être tenu de
                                        souscrire directement auprès de Pennylane une offre correspondant à ses besoins
                                        afin de continuer à bénéficier de tout ou partie des services concernés.
                                    </p>
                                    <p>
                                        Les conditions tarifaires, modalités de souscription et limites applicables
                                        au-delà de ce plafond sont définies par Pennylane et relèvent exclusivement de
                                        la relation contractuelle entre Pennylane et l’Utilisateur Professionnel.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.5. Responsabilité de
                                        l’Utilisateur Professionnel</div>
                                    <p>
                                        L’Utilisateur Professionnel demeure seul responsable de l’exactitude, de
                                        l’exhaustivité et de la conformité des informations figurant sur les documents
                                        créés ou transmis au moyen de la Plateforme topela.
                                    </p>
                                    <p>Il lui appartient notamment de vérifier :</p>
                                    <ul>
                                        <li>son identité et celle de son client ;</li>
                                        <li>les numéros SIREN, SIRET et de TVA ;</li>
                                        <li>les montants facturés ;</li>
                                        <li>les taux et règles de TVA appliqués ;</li>
                                        <li>la nature de l’opération ;</li>
                                        <li>la qualité professionnelle ou particulière du client ;</li>
                                        <li>les informations relatives aux encaissements et aux paiements ;</li>
                                        <li>les mentions légales et réglementaires applicables.</li>
                                    </ul>
                                    <p>
                                        L’Utilisateur Professionnel demeure également seul responsable de
                                        l’identification des opérations soumises à la facturation électronique ou à la
                                        transmission électronique des données de transaction et de paiement. Il lui
                                        appartient d’utiliser les modalités de transmission appropriées et de respecter
                                        les obligations légales et réglementaires applicables à son activité.
                                    </p>
                                    <p>
                                        L’utilisation de Topela ne dispense pas l’Utilisateur Professionnel de suivre
                                        les statuts de transmission de ses factures, de traiter les éventuels rejets ou
                                        demandes de correction et de satisfaire à ses obligations comptables, fiscales
                                        et de conservation des documents.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.6. Responsabilité de Webck
                                        et recours à Pennylane</div>
                                    <p>
                                        Webck assure la mise à disposition de l’interface Topela et de la passerelle
                                        technique permettant les échanges de données avec Pennylane.
                                    </p>
                                    <p>
                                        Dans le cadre de l’activation du service de facturation électronique, certaines
                                        données de l’Utilisateur Professionnel peuvent être transmises à Pennylane afin
                                        d’initier la création ou la connexion de son compte. Ces données sont limitées
                                        aux informations nécessaires à cette activation, notamment l’adresse e-mail, le
                                        nom, le prénom et le SIRET de l’entreprise. Cette transmission intervient
                                        uniquement lorsque l’Utilisateur choisit d’activer le service depuis Topela.
                                    </p>
                                    <p>
                                        Pennylane demeure responsable des opérations réalisées au moyen de ses propres
                                        services, notamment du traitement, de la transmission et de la réception des
                                        factures électroniques ainsi que de la transmission des données réglementaires à
                                        l’administration fiscale.
                                    </p>
                                    <p>
                                        Webck ne saurait être tenue responsable des retards, rejets, erreurs,
                                        interruptions ou dysfonctionnements exclusivement imputables à Pennylane, à la
                                        plateforme du destinataire, aux infrastructures de l’administration fiscale ou à
                                        tout autre service tiers.
                                    </p>
                                    <p>
                                        Webck demeure toutefois responsable des manquements qui lui seraient directement
                                        imputables dans le fonctionnement de la Plateforme topela ou de sa passerelle
                                        technique, dans les limites prévues par les présentes CGU.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.7. Services et liens de
                                        paiement proposés par Pennylane</div>
                                    <p>
                                        Les fonctionnalités, liens et modalités de paiement éventuellement proposés par
                                        Pennylane constituent des services extérieurs à la Plateforme topela.
                                    </p>
                                    <p>
                                        Webck n’intervient ni dans la fourniture de ces services de paiement, ni dans
                                        l’encaissement, le transfert ou le remboursement des sommes correspondantes.
                                    </p>
                                    <p>
                                        Leur utilisation relève exclusivement de la relation entre l’Utilisateur
                                        Professionnel, Pennylane et, le cas échéant, le prestataire de paiement
                                        concerné. Toute réclamation portant sur ces services doit être adressée
                                        directement au prestataire concerné.
                                    </p>

                                    <div class="h4 h-style h4-style use-poppins mt-4 mb-2">10.8. Évolution du Service
                                    </div>
                                    <p>
                                        Les fonctionnalités du Service de facturation électronique peuvent évoluer afin
                                        de tenir compte des modifications légales, réglementaires, normatives ou
                                        techniques ainsi que des évolutions apportées aux services de la Plateforme
                                        Agréée partenaire.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">11. Données </div>
                                    <p>
                                        L’Utilisateur reconnaît et accepte expressément que les données recueillies sur
                                        la Plateforme topela font foi de la réalité des opérations intervenues dans le
                                        cadre des présentes.
                                    </p>
                                    <p>
                                        L’Utilisateur peut accéder à ces données dans son Espace Personnel.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">12. Sécurité</div>
                                    <p>
                                        Webck s'engage à ce que :
                                    </p>
                                    <div>
                                        <ul>
                                            <li>
                                                L’accès aux installations et équipements informatiques de Webck soit
                                                protégé de manière à empêcher l’accès non-autorisé par des tiers ;
                                            </li>
                                            <li>
                                                L’infrastructure de la Plateforme topela soit protégée par des firewalls
                                                et des systèmes de tracking ;
                                            </li>
                                            <li>
                                                La Plateforme topela soit mise à jour régulièrement afin de garantir la
                                                sécurité au niveau applicatif et afin de limiter les failles de
                                                sécurité.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">13. Obligations de l’Utilisateur</div>
                                    <p>
                                        Sans préjudice des autres obligations prévues aux présentes, l’Utilisateur
                                        s’engage à respecter les obligations qui suivent :
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage, dans son usage des Services, à respecter les lois et
                                        règlements en vigueur et à ne pas porter atteinte aux droits de tiers ou à
                                        l’ordre public.
                                    </p>
                                    <p>
                                        Il est notamment seul responsable du bon accomplissement de toutes les
                                        formalités notamment administratives, fiscales et/ ou sociales et de tous les
                                        paiements de prestations, taxes ou impôts de toutes natures qui lui incombent,
                                        le cas échéant, en relation avec son utilisation des Services. La responsabilité
                                        de Webck ne pourra en aucun cas être engagée à ce titre.
                                    </p>
                                    <p>
                                        L’Utilisateur reconnaît avoir pris connaissance sur la Plateforme topela des
                                        caractéristiques et contraintes, notamment techniques, de l’ensemble des
                                        Services. Il est seul responsable de son utilisation des Services.
                                    </p>
                                    <p>
                                        L’Utilisateur est informé et accepte que la mise en œuvre des Services nécessite
                                        qu’il soit connecté à internet et que la qualité des Services dépend directement
                                        de cette connexion, dont il est seul responsable.
                                    </p>
                                    <p>
                                        L’Utilisateur est également seul responsable des relations qu’il pourra nouer
                                        avec les autres Utilisateurs et des informations qu’il leur communique dans
                                        le cadre des Services. Il lui appartient d’exercer la prudence et le
                                        discernement appropriés dans ces relations et communications.
                                        L’Utilisateur s’engage en outre, dans ses échanges avec les autres Utilisateurs,
                                        à respecter les règles usuelles de politesse et de courtoisie.
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage à faire un usage strictement personnel des Services. Il
                                        s’interdit en conséquence de céder, concéder ou transférer tout ou partie de ses
                                        droits ou obligations au titre des présentes à un tiers, de quelque manière que
                                        ce soit.
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage à fournir à Webck toutes les informations nécessaires à
                                        la bonne exécution des Services. Plus généralement, l’Utilisateur s’engage à
                                        coopérer activement avec Webck en vue de la bonne exécution des présentes.
                                    </p>
                                    <p>
                                        L’Utilisateur est seul responsable des contenus de toute nature (rédactionnels,
                                        graphiques, audiovisuels ou autres, en ce compris la dénomination et/ou l’image
                                        éventuellement choisies par l’Utilisateur pour l’identifier sur le site) qu’il
                                        diffuse dans le cadre des Services (ci-après désignés : les <strong>« Contenus
                                            »</strong>).
                                    </p>
                                    <p>
                                        Il garantit à Webck qu’il dispose de tous les droits et autorisations
                                        nécessaires à la diffusion de ces Contenus.
                                    </p>
                                    <p>
                                        Il s’engage à ce que lesdits Contenus soient licites, ne portent pas atteinte à
                                        l’ordre public, aux bonnes mœurs ou aux droits de tiers, n’enfreignent aucune
                                        disposition législative ou règlementaire et plus généralement, ne soient
                                        aucunement susceptibles de mettre en jeu la responsabilité civile ou pénale de
                                        Webck.
                                    </p>
                                    <p>
                                        L’Utilisateur doit prendre les mesures nécessaires pour sauvegarder par ses
                                        propres moyens les informations qu’il juge nécessaires, dont aucune copie ne lui
                                        sera fournie.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">14. Garantie de l’Utilisateur</div>
                                    <p>
                                        L’Utilisateur garantit Webck contre toutes plaintes, réclamations, actions et/ou
                                        revendications quelconques que Webck pourrait subir du fait de la violation,
                                        par l’Utilisateur de l’une quelconque de ses obligations ou garanties aux termes
                                        des présentes conditions générales.
                                    </p>
                                    <p>
                                        Il s’engage à indemniser Webck de tout préjudice qu’elle subirait et à lui payer
                                        tous les frais, charges et/ou condamnations qu’elle pourrait avoir à supporter
                                        de ce fait.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">15. Comportements prohibés</div>
                                    <p>
                                        Il est strictement interdit d’utiliser les Services aux fins suivantes :
                                    </p>
                                    <div>
                                        <ul>
                                            <li>
                                                l’exercice d’activités illégales, frauduleuses ou portant atteinte aux
                                                droits ou à la sécurité des tiers,
                                            </li>
                                            <li>
                                                l’atteinte à l’ordre public ou la violation des lois et règlements en
                                                vigueur,
                                            </li>
                                            <li>
                                                l’intrusion dans le système informatique d’un tiers ou toute activité de
                                                nature à nuire, contrôler, interférer, ou intercepter tout ou partie du
                                                système informatique d’un tiers, en violer l’intégrité ou la sécurité,
                                            </li>
                                            <li>
                                                l’envoi d’emails non sollicités et/ou de prospection ou sollicitation
                                                commerciale,
                                            </li>
                                            <li>
                                                les manipulations destinées à améliorer le référencement d’un site
                                                tiers,
                                            </li>
                                            <li>
                                                l’aide ou l’incitation, sous quelque forme et de quelque manière que ce
                                                soit, à un ou plusieurs des actes et activités décrits ci-dessus,
                                            </li>
                                            <li>
                                                et plus généralement toute pratique détournant les Services à des fins
                                                autres que celles pour lesquelles ils ont été conçus.
                                            </li>
                                        </ul>
                                    </div>
                                    <p>
                                        Il est strictement interdit aux Utilisateurs de copier et/ou de détourner à
                                        leurs fins ou à celles de tiers le concept, les technologies ou tout autre
                                        élément de la Plateforme topela de Webck.
                                    </p>
                                    <p>
                                        Sont également strictement interdits :
                                        (i) tous comportements de nature à interrompre, suspendre, ralentir ou empêcher
                                        la continuité des Services,
                                        (ii) toutes intrusions ou tentatives d’intrusions dans les systèmes de Webck,
                                        (iii) tous détournements des ressources système du site,
                                        (iv) toutes actions de nature à imposer une charge disproportionnée sur les
                                        infrastructures de ce dernier,
                                        (v) toutes atteintes aux mesures de sécurité et d’authentification,
                                        (vi) tous actes de nature à porter atteinte aux droits et intérêts financiers,
                                        commerciaux ou moraux de Webck ou des usagers de son site, et enfin plus
                                        généralement
                                        (vii) tout manquement aux présentes conditions générales.
                                    </p>
                                    <p>
                                        Il est strictement interdit de monnayer, vendre ou concéder tout ou partie de
                                        l’accès aux Services ou à la Plateforme topela, ainsi qu’aux informations qui y
                                        sont hébergées et/ou partagées.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">16. Sanctions des manquements</div>
                                    <p>
                                        En cas de manquement à l’une quelconque des dispositions des présentes
                                        conditions générales ou plus généralement, d’infraction aux lois et règlements
                                        en
                                        vigueur par un Utilisateur, Webck se réserve le droit de prendre toute mesure
                                        appropriée et notamment de :
                                    </p>
                                    <div>
                                        <ul>
                                            <li>
                                                suspendre ou résilier l’accès aux Services de l’Utilisateur, auteur du
                                                manquement ou de l’infraction, ou y ayant participé,
                                            </li>
                                            <li>
                                                supprimer tout contenu mis en ligne sur le site,
                                            </li>
                                            <li>
                                                publier sur le site tout message d’information que Webck jugera utile,
                                            </li>
                                            <li>
                                                avertir toute autorité concernée,
                                            </li>
                                            <li>
                                                engager toute action judiciaire.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">17. Responsabilité de Webck</div>
                                    <p>
                                        Webck s’engage à fournir les Services avec diligence et selon les règles de
                                        l’art, étant précisé qu’il pèse sur elle une obligation de moyens,
                                        à l’exclusion de toute obligation de résultat, ce que les Utilisateurs
                                        reconnaissent et acceptent expressément.
                                    </p>
                                    <p>
                                        Webck n’a pas connaissance des Contenus mis en ligne par les Utilisateurs dans
                                        le cadre des Services, sur lesquels elle n’effectue
                                        aucune modération, sélection, vérification ou contrôle d’aucune sorte et à
                                        l’égard desquels elle n’intervient qu’en tant que prestataire d’hébergement.
                                    </p>
                                    <p>
                                        Il est précisé que Webck n’intervient, à aucun moment, dans les parcours de
                                        relation d’affaire entre les Utilisateurs Clients et Professionnels. <br>
                                        En conséquence, Webck ne peut être tenue pour responsable des Contenus, dont les
                                        auteurs sont des tiers, toute réclamation éventuelle devant être dirigée en
                                        premier lieu vers l’auteur des Contenus en question. Webck ne saurait non plus
                                        être tenue responsable des choix réalisés par les Utilisateurs lors de
                                        l’utilisation des Services.
                                    </p>
                                    <p>
                                        L’Utilisateur Professionnel sera donc seul et exclusivement responsable de tout
                                        dommage (y compris dommage/préjudice matériel de nature économique ou financière
                                        tel qu’une perte de client(s),
                                        un préjudice financier, un gain manqué, etc.) résultant de toute erreur ou
                                        inexactitude (contenu, information, données, chiffres, totaux, etc.) figurant
                                        sur tout document (par exemple devis ou factures, etc.)
                                        (i) émis par la Plateforme topela,
                                        (ii) envoyé manuellement par l’Utilisateur à ses clients, et
                                        (iii) utilisé directement ou indirectement par l’Utilisateur Professionnel, par
                                        ses clients et/ou par tout autre tiers. Avant de procéder à tout envoi,
                                        l’Utilisateur Professionnel doit donc vérifier que le contenu des documents émis
                                        via la Plateforme topela et destinés aux Utilisateurs Client est parfaitement
                                        correct.
                                    </p>
                                    <p>
                                        Les Contenus préjudiciables à un tiers peuvent faire l’objet d’une notification
                                        à Webck selon les modalités prévues par l’article 6 I 5 de la loi n° 2004-575 du
                                        21 juin 2004 pour la confiance dans l'économie numérique, Webck se réservant de
                                        prendre les mesures décrites à l’article 16.
                                    </p>
                                    <p>
                                        Webck maintient en principe accessible les Services de la Plateforme topela 7
                                        jours sur 7 et 24 heures sur 24. Elle s’engage à procéder
                                        régulièrement à des contrôles afin de vérifier le fonctionnement et
                                        l’accessibilité de la Plateforme topela. A ce titre, Webck se réserve la faculté
                                        d’interrompre momentanément l’accès à la Plateforme topela pour des raisons de
                                        maintenance ou de mise à jour. De même, Webck ne saurait être tenue responsable
                                        des difficultés ou impossibilités momentanées d’accès à la Plateforme topela qui
                                        auraient pour origine des circonstances qui lui sont extérieures, la force
                                        majeure, qui seraient dues à
                                        des perturbations des réseaux de télécommunication ou encore qui seraient
                                        imputables à des installations ou équipements informatiques de l’Utilisateur qui
                                        s’avèreraient non adaptés ou défaillants.
                                    </p>
                                    <p>
                                        Webck ne garantit pas la compatibilité du Site Web avec tous les navigateurs du
                                        marché. De même, Webck ne garantit pas la comptabilité de l’Application Mobile
                                        topela avec tous les smartphones du marché.
                                    </p>
                                    <p>
                                        Webck ne garantit pas aux Utilisateurs (i) que les Services, soumis à une
                                        recherche constante pour en améliorer notamment la performance et le progrès,
                                        seront totalement exempts d’erreurs, de vices ou défauts,
                                        (ii) que les Services, étant standard et nullement proposés à la seule intention
                                        d’un Utilisateur donné en fonction de ses propres contraintes personnelles,
                                        répondront spécifiquement à ses besoins et attentes.
                                    </p>
                                    <p>
                                        En tout état de cause, la responsabilité susceptible d’être encourue par Webck
                                        au titre des présentes est expressément limitée aux seuls dommages directs
                                        avérés subis par l’Utilisateur.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">18. Droits de Propriété Intellectuelle
                                    </div>
                                    <p>
                                        Les systèmes, logiciels, structures, infrastructures, bases de données et
                                        contenus de toute nature (textes, images animées ou non, visuels, musiques,
                                        logos, marques, base de données, structure générale des fonctionnalités,
                                        savoir-faire etc.) exploités par Webck au sein de la Plateforme topela sont
                                        protégés par
                                        tous droits de propriété intellectuelle ou droits des producteurs de bases de
                                        données en vigueur. Tous désassemblages, décompilations, décryptages,
                                        extractions,
                                        réutilisations, copies et plus généralement, tous actes de reproduction,
                                        représentation, diffusion et utilisation de
                                        l’un quelconque de ces éléments, en tout ou partie, sans l’autorisation de Webck
                                        sont strictement interdits et pourront faire l’objet de poursuites judiciaires.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">19. Données à caractère personnel</div>
                                    <p>
                                        Webck pratique une politique de protection des données personnelles dont les
                                        caractéristiques sont explicitées dans le document
                                        intitulé <a href="/privacy-policy" target="_blanc"
                                            style="text-decoration: underline !important;color:#0070C0 !important;">«
                                            Politique de confidentialité »</a>, dont l’Utilisateur est expressément
                                        invité à prendre connaissance sur le Site.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">20. Liens et sites tiers</div>
                                    <p>
                                        Webck ne pourra en aucun cas être tenue pour responsable de la disponibilité
                                        technique de sites internet ou d’applications mobiles exploités par des tiers
                                        (y compris ses éventuels partenaires) auxquels l’Utilisateur accéderait par
                                        l’intermédiaire de la Plateforme topela.
                                    </p>
                                    <p>
                                        Webck n'endosse aucune responsabilité au titre des contenus, publicités,
                                        produits et/ou services disponibles sur de tels sites et
                                        applications mobiles tiers dont il est rappelé qu’ils sont régis par leurs
                                        propres conditions d’utilisation.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">21. Durée des services et désactivation
                                        (désinscription)</div>
                                    <p>
                                        Les Services mis à disposition des Utilisateurs Clients et Professionnels
                                        inscrits le sont pour une durée indéterminée.
                                    </p>
                                    <p>
                                        Toutefois, Webck se réserve le droit de désactiver les comptes d’Utilisateurs
                                        restés inactifs pendant une période supérieure ou égale à un (1) an.
                                    </p>
                                    <p>
                                        L’Utilisateur peut à tout instant demander la désactivation de son compte
                                        (désinscription) en adressant un email à l'adresse suivante : <a
                                            href="mailto:sav@123topela.fr"
                                            style="text-decoration: underline;color:blue">sav@123topela.fr</a>.
                                        Les modalités de la désinscription (désactivation) sont précisées en article 3
                                        (pour un Utilisateur Client) et en article 4 (pour un Utilisateur Professionnel)
                                        de notre <a
                                            style="text-decoration: underline !important;color:#0070C0 !important;"
                                            target="_blanc" href="/privacy-policy">Politique de confidentialité</a>.
                                    </p>
                                </div>
                                <div id="">
                                    <div class="h3 h-style h3-style use-poppins">22. Modifications</div>
                                    <p>
                                        Webck se réserve la faculté de modifier, corriger et compléter à tout moment les
                                        présentes conditions générales. Ces modifications entreront en vigueur à compter
                                        de leur publication sur notre site web.
                                        Nous vous recommandons de consulter régulièrement les présentes conditions
                                        générales pour prendre connaissance des modifications apportées.
                                    </p>
                                    <p>
                                        L’Utilisateur qui n’accepte pas les conditions générales modifiées doit se
                                        désinscrire des Services selon les modalités prévues à l’article 21.
                                    </p>
                                    <p>
                                        Tout Utilisateur qui a recours aux Services postérieurement à l’entrée en
                                        vigueur des conditions générales modifiées est réputé avoir accepté ces
                                        modifications.
                                    </p>
                                </div>
                                <div id="23">
                                    <div class="h3 h-style h3-style use-poppins">23. Langue</div>
                                    <p>
                                        Les présentes conditions générales d'utilisation sont rédigées en langue
                                        française.
                                    </p>
                                    <p>
                                        Dans l’hypothèse d’une traduction des présentes conditions générales dans une ou
                                        plusieurs langues, la langue d’interprétation sera la langue française en cas de
                                        contradiction ou de contestation sur la signification d’un terme ou d’une
                                        disposition.
                                    </p>
                                </div>
                                <div id="" class="mb-5">
                                    <div class="h3 h-style h3-style use-poppins">24. Droit applicable et juridiction
                                    </div>
                                    <p>
                                        Les présentes conditions générales d’utilisation sont régies et soumises au
                                        droit français.
                                    </p>
                                    <p>
                                        En cas de contestation sur la validité, l’interprétation et/ou l’exécution des
                                        présentes conditions générales,
                                        les parties conviennent que les tribunaux de Paris seront exclusivement
                                        compétents pour en juger, sauf règles de procédure impératives contraires.
                                    </p>
                                </div>
                                <div id="old_versions" class="mb-5">
                                    <div class="h3 h-style h3-style use-poppins">Versions antérieures</div>
                                    <div>
                                        <ul>
                                            <li>
                                                <Link href="/general-conditions-of-use/v2026-03-01/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 1er mars 2026
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-use/v2025-07-04/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 04 juillet 2025
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-use/v2024-05-12/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 12 mai 2025
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-use/v2024-03-18/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 18 mars 2025
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-use/v2024-08-01/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 1er août 2024
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mb-3"></div> -->
                </section>
            </main>
        </div>
    </Default>
</template>

<style scoped>
body {
    font-family: "Century Gothic", sans-serif;
    color: #233648;
}

p {
    color: rgb(75, 75, 75);
    margin-top: 0;
    margin-bottom: 0.5em !important;
}

ul li {
    list-style: disc;
}

h3,
.h3 {
    font-size: 20px !important;
    margin-bottom: 0.5em !important;
    margin-top: 15px !important;
}

h4 {
    font-size: 16px !important;
    margin-bottom: 0.2rem !important;
}

.h4 {
    font-size: 16px !important;
    color: #7f6d68;
    margin-bottom: 0.2rem !important;
}

.h3 {
    font-weight: bold;
}
</style>